import { gql } from 'graphql-tag';

// Mutation to start the export
export const EXPORT_CUSTOMERS_V3 = gql`
  mutation ExportCustomers($input: GetCustomersV3Input!) {
    exportCustomersV3(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export progress
export const CUSTOMER_EXPORT_STATUS = gql`
  subscription ExportProgress($jobId: String!) {
    customerExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
      createdAt
      completedAt
    }
  }
`;

// Query to get the download URL
export const GET_EXPORT_DOWNLOAD_URL = gql`
  query GetDownloadUrl($jobId: String!) {
    getExportDownloadUrl(jobId: $jobId)
  }
`;
